/**
 * External Dependencies
 */
import $ from 'jquery'
import fancybox from '@fancyapps/fancybox'

//slick
import slick from 'slick-carousel'

$(() => {
  // console.log('Hello world')


  //Main Menu open/close
  $('.menu-open').on('click', function(e) {
    $('.overlay-menu').css('width','100%');
    e.preventDefault();
  });
  $('.menu-close').on('click', function(e) {
    $('.overlay-menu').css('width','0%');
    e.preventDefault();
  });

  //text expand
  /*$('#toggleContent').on('click', function() {
      const contentDiv = $('.text-more');
      if (contentDiv.hasClass('expanded')) {
          contentDiv.removeClass('expanded');
          $(this).text('Visualizza la trascrizione');
      } else {
          contentDiv.addClass('expanded');
          $(this).text('Nascondi la trascrizione');
      }
  });*/


  $('.nav-blog li.active').last().find('a').css('text-decoration', 'underline');


  //Progress bar
  $(window).on('scroll', function() {
      var scrollTop = $(this).scrollTop();
      var docHeight = $(document).height();
      var windowHeight = $(this).height();

      var scrollPercent = (scrollTop) / (docHeight - windowHeight);
      var scrollPercentRounded = Math.round(scrollPercent * 100);

      $('#progress-bar').css('height', scrollPercentRounded + '%');
  });


  //Slider articoli
  $('.slider-articoli').slick({
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    pauseOnHover: false,
    dots: false,
    responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });

})
